import { render, staticRenderFns } from "./SelectObjectCity.vue?vue&type=template&id=3ed4faa4&"
import script from "./SelectObjectCity.vue?vue&type=script&lang=js&"
export * from "./SelectObjectCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports